import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Denounce } from '../../../core/models/denounce.model';
import { Component, Inject, OnInit } from '@angular/core';
import { UtilsService } from '../../../core/services/utils.service';
import { ComplaintsService } from '../../../core/services/complaints.service';
import { ToastrService } from 'ngx-toastr';

@Component({
	selector: 'app-modal-history-status',
	templateUrl: './modal-history-status.component.html',
	styleUrls: ['./modal-history-status.component.scss'],
})
export class ModalHistoryStatusComponent implements OnInit {
	s;
	denounce: any;
	depoimento: String;
	public loading = true;

	listStatus: any[] = [];

	selectedStatus = [
		{
			main: 'Relato registrado',
			sub: 'SUB_STATUS_RECEIVED',
			name: 'Relato recebido pelo órgão responsável',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_ANALYSIS',
			name: 'Órgão responsável identificando imagens',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_FOUND',
			name: 'Imagens encontradas e sob análise',
		},
		{
			main: 'Em análise',
			sub: 'SUB_STATUS_IMAGE_NOT_FOUND',
			name: 'Não foi possivel encontrar imagens do caso',
		},
		{
			main: 'Análise concluída',
			sub: 'SUB_STATUS_IMAGE_FORWARDED',
			name: 'Relato concluído',
		},
		{
			main: 'Análise concluída',
			sub: 'SUB_STATUS_INCONCLUSIVE',
			name: 'Relato inconclusivo - poucas informações',
		},
	];

	private confirmedUser: boolean;

	historyStatus: any[] = [];

	user = {
		gender: '',
		age: 0,
	};

	constructor(
		public utils: UtilsService,
		private toastr: ToastrService,
		private complaintsService: ComplaintsService,
		public dialogRef: MatDialogRef<ModalHistoryStatusComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.denounce = this.data['denounce'];
		this.historyStatus = this.denounce.status_history;
		this.listStatus = this.groupAndSortByMainStatus(
			this.historyStatus,
			this.selectedStatus
		);
	}

	ngOnInit(): any {}

	ngAfterViewInit(): void {
		this.calcularAltura();
	}

	closeModal(): void {
		this.dialogRef.close();
	}

	putStatusDenounce(): void {}

	cutString(text: string): string {
		if (text.length > 12) {
			return text.substring(0, 12) + '...';
		} else {
			return text;
		}
	}

	groupAndSortByMainStatus(objetos, statusList) {
		const mainStatusToName = {};
		statusList.forEach((status) => {
			mainStatusToName[status.main] = status.name;
		});

		const groupedStatus: Record<string, any[]> = {};
		objetos.forEach((objeto) => {
			const mainStatus = objeto.status.main;
			if (mainStatusToName[mainStatus]) {
				if (!groupedStatus[mainStatus]) {
					groupedStatus[mainStatus] = [];
				}
				groupedStatus[mainStatus].push(objeto);
			}
		});

		for (const mainStatus in groupedStatus) {
			groupedStatus[mainStatus].sort((a, b) => {
				const dateA = new Date(a.created_at);
				const dateB = new Date(b.created_at);
				return dateA.getTime() - dateB.getTime();
			});
		}

		// Crie uma lista de listas ordenadas
		const listaTotal: any[][] = [];

		for (const mainStatus in groupedStatus) {
			listaTotal.push(groupedStatus[mainStatus]);
		}

		// Ordene as sublistas com base na data
		listaTotal.forEach((sublista) => {
			sublista.sort((a, b) => {
				const dateA = new Date(a.created_at);
				const dateB = new Date(b.created_at);
				return dateA.getTime() - dateB.getTime();
			});
		});

		return listaTotal;
	}

	calcularAltura() {
		this.listStatus.forEach((sublista, index) => {
			if (index < this.listStatus.length - 1) {
				let statusConteiner = document?.querySelector(`.status-container-step`);
				let statusStep = statusConteiner?.querySelector(`#status-${index}`);
				let containerElipse = statusStep?.querySelector(`.container-elipse`);
				containerElipse?.setAttribute(
					'style',
					`height: ${statusStep?.clientHeight}px;`
				);
			}
		});
	}

	formatarData(data: Date): string {
		data = new Date(data);
		if (data) {
			const dia = String(data.getDate()).padStart(2, '0');
			const mes = String(data.getMonth() + 1).padStart(2, '0'); // Os meses são base 0, então adicionamos 1
			const ano = String(data.getFullYear()).substr(2, 2);
			const hora = String(data.getHours()).padStart(2, '0');
			const minutos = String(data.getMinutes()).padStart(2, '0');

			return `${dia}/${mes}/${ano} - ${hora}:${minutos}`;
		}
	}
}
